export const dermatologyMarkTypes = {
  L: { label: 'Lunar', code: 'COUNT_MOLES', color: '#B43E23' },
  P: { label: 'Peca', code: 'COUNT_FRECKLES', color: '#B43E23' },
  M: { label: 'Mancha', code: 'COUNT_SPOTS', color: '#B43E23' },
  C: { label: 'Cicatriz', code: 'COUNT_SCARS', color: '#B43E23' },
  O: { label: 'Otras', code: 'COUNT_OTHERS', color: '#B43E23' },
};

export const getMarkTypeByCode = (code) => {
  return Object.entries(dermatologyMarkTypes).find(([_, value]) => value.code === code)?.[0];
};

export const calculateCounts = (marks) => {
  const counts = {
    COUNT_MOLES: 0,
    COUNT_FRECKLES: 0,
    COUNT_SPOTS: 0,
    COUNT_SCARS: 0,
    COUNT_OTHERS: 0,
  };

  marks.forEach((mark) => {
    const config = dermatologyMarkTypes[mark.type];
    if (config && counts[config.code] !== undefined) {
      counts[config.code]++;
    }
  });

  return counts;
};

export const fitzpatrickScale = {
  I: { color: '#F9EBD2' },
  II: { color: '#F3D1AC' },
  III: { color: '#DEAB7E' },
  IV: { color: '#C5814F' },
  V: { color: '#925431' },
  VI: { color: '#563628' },
};
